import { StatusOption } from '../../utils'

export enum EventStatusEnum {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  SOLVED = 'SOLVED'
}

export const eventStatusEnumMapping: Record<EventStatusEnum, StatusOption> = {
  [EventStatusEnum.CREATED]: {
    label: 'À assigner',
    variant: 'warning'
  },
  [EventStatusEnum.IN_PROGRESS]: {
    label: 'En cours',
    variant: 'blue'
  },
  [EventStatusEnum.SOLVED]: {
    label: 'Clôturés',
    variant: 'success'
  }
}
